import { Fragment, useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Layout } from 'antd';
import { useLocation } from 'react-router-dom';
import Facadeaction from './Facadeaction';
import Facadesetting from './Facadesetting';
import Cumputerpreview from '../../components/Cumputerpreview';
import Mobilpreview from '../../components/Mobilpreview';
import './index.less';

const Facade = (_, ref) => {
    const { Content, Sider } = Layout;
    const [cumputer, setCumputer] = useState(true);
    const [mobile, setMobile] = useState(false);
    const [cumputerCover, setCumputerCover] = useState(undefined);
    const [mobileCover, setMobileCover] = useState(undefined);
    const [surveyTitle, setSurveyTitle] = useState(undefined);
    const location = useLocation();
    const [displayTitle, setDisplayTitle] = useState(undefined);
    const [displayCopyright, setDisplayCopyright] = useState(undefined);
    const [displayLogo, setDisplayLogo] = useState(undefined);
    const [setting, setSetting] = useState(undefined);
    const [color, setColor] = useState({ r: '255', g: '255', b: '255', a: '1' });
    const [selectColor, setSelectColor] = useState(false);

    useImperativeHandle(ref, () => ({
        surveyTitle,
    }));
    const changeCumputer = () => {
        setCumputer(true);
        setMobile(false);
    };

    const changeMobile = () => {
        setCumputer(false);
        setMobile(true);
    };

    const change = type => {
        if (type.includes('pc')) {
            setCumputerCover(type);
            setMobileCover(type);
            setCumputer(true);
            setMobile(false);
        } else if (type.includes('app')) {
            setCumputerCover(type);
            setMobileCover(type);
            setCumputer(false);
            setMobile(true);
        }
    };

    useEffect(() => {
        setSurveyTitle(location.state.title);
    }, []);

    return (
        <Fragment>
            <Sider className="survey-action vertical-scrollbar" width={220}>
                <Facadeaction change={change} setMobile={setMobile} setting={setting} setSetting={setSetting} />
            </Sider>
            <div className="page-route-body crosswise-scrollbar">
                <div className="main-content-body">
                    <div>
                        <div className="preview-center">
                            <div className="preview-action" onClick={changeCumputer} style={cumputer ? { color: '#1a73e8' } : {}}>
                                <i className="bi bi-display"></i>
                                <p>电脑</p>
                            </div>
                            <div className="preview-action" onClick={changeMobile} style={mobile ? { color: '#1a73e8' } : {}}>
                                <i className="bi bi-phone"></i>
                                <p>手机</p>
                            </div>
                        </div>

                        {cumputer && <Cumputerpreview content={location.state} type={cumputerCover} displayTitle={displayTitle} displayCopyright={displayCopyright} displayLogo={displayLogo} selectColor={selectColor} />}
                        {mobile && <Mobilpreview content={location.state} type={mobileCover} displayTitle={displayTitle} displayCopyright={displayCopyright} displayLogo={displayLogo} selectColor={selectColor} />}
                    </div>
                </div>
            </div>
            <Sider className="wj-facade-setting-sider vertical-scrollbar" theme="light" width={230}>
                <Facadesetting
                    change={change}
                    setMobile={setMobile}
                    displayTitle={displayTitle}
                    displayCopyright={displayCopyright}
                    displayLogo={displayLogo}
                    setDisplayTitle={setDisplayTitle}
                    setDisplayCopyright={setDisplayCopyright}
                    setDisplayLogo={setDisplayLogo}
                    color={color}
                    setColor={setColor}
                    selectColor={selectColor}
                    setSelectColor={setSelectColor}
                    setting={setting}
                />
            </Sider>
        </Fragment>
    );
};

export default forwardRef(Facade);
